import React, { Component } from 'react';
import * as d3 from 'd3';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Quadrant from './components/Quadrant';
import scatterPlot from './utils/scatterPlot';
import logo from './logo.svg';
import './App.css';
import * as Actions from './store/actions';
import qbData from './utils/data.js';

class App extends Component {

  componentWillMount() {
    this.updateDimensions();

  }
  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);

    qbData.forEach( (d) => {
      d.rating = +d.rating;
      d.points = (+d.points);
      d.snaps = +d.snaps;
      d.snapPct = +d.snapPct;
      d.complete = (d.snapPct === 100)
    });

    this.props.actions.updateData(qbData);

    let q = scatterPlot().data(qbData)
    this.props.actions.setInfographic(q);

    d3.select('#quadrant').call(q);
  }

  componentDidUpdate() {
    this.props.appState.infographic
      .size(this.props.appState.size)
      .title("NFL Quarterback Performance")
      .draw()

  }

    // Set window dimensions / mobile status in Redux
  updateDimensions = () => {
    const el = document.getElementById('about')
    const offset = el ? el.getBoundingClientRect().height + 40 : 140
    const size = {
      width: window.innerWidth,
      height: window.innerHeight - offset,
    };
    this.props.actions.setWindowSize(size);
    if (this.props.appState.infographic) {
      this.props.appState.infographic
        .size(this.props.appState.size)
        .title("NFL Quarterback Performance")
        .draw()
    }
  }

  render() {
    return (
      <div className="App">
        <div id="about">
          <h2>NFL quarterback performances - week 1</h2>
          <p>QB Rating is on the horizontal axis.  Point differential on the vertical (negative differential indicates a loss).
          </p>
          <p className="footnote">* = incomplete game
          </p>
        </div>
        <Quadrant />
        <div id="tooltip" className="tooltip"/>
        <div>
          Notes: NFL Data is hard to find!  The point differential is the difference in score. It does not take into account the percentage of playing time for players that were replaced.
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  appState: state.appState,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js